class StaffUtils {

    isDoctor(staff) {
        return staff.staffType === "DOCTOR";
    }

}

export default new StaffUtils();